/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import { useRouter, Redirect } from '@atlassian/react-resource-router';

export const OnCallRedirect = (): React.JSX.Element => {
	const [routeContext] = useRouter();
	const redirectionUrl = `${routeContext.location.pathname}/on-call`;
	return <Redirect to={redirectionUrl} />;
};

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyOnCall: LazyComponent<any> = lazyForPaint<any>(
	() =>
		import(
			/* webpackChunkName: "async-jira-eoc-on-call", jiraSpaEntry: "async-jira-eoc-on-call" */ '@jira/eoc__on-call/src/index.tsx'
		),
);

const AsyncOnCall = (): React.JSX.Element => (
	<LazyPage Page={LazyOnCall} pageId="async-jira-eoc-on-call" shouldShowSpinner={false} />
);

export default AsyncOnCall;
